import { tss } from 'tss-react/mui';

export const useStyles = tss.create(() => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '0px 8px',
  },
  agent: {
    padding: '30px',
  },
  agent_header: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'flex-end',
  },
  agent_table: {
    marginTop: '20px',
    '& table': {
      tableLayout: 'fixed',
      width: '100%',
    },
  },
  agent_create_button: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 14px',
    gap: '6px',
    height: '40px',
    background: '#1875FF',
    borderRadius: '8px',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '140%',
  },
  agent_table_row: {
    cursor: 'pointer',
  },
  agent_table_first_cell: {
    // display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: '7px',
    fontWeight: 'bold !important',
  },
  agent_table_sort_cell: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  agent_table_popover: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px',
  },
  agent_table_popover_button: {
    gap: '11px',
    justifyContent: 'start',
    borderRadius: '4px',
  },
  nameCell: {
    minWidth: '160px',
    width: '160px',
    maxWidth: '160px',
  },
  sexCell: {
    minWidth: '85px',
    width: '85px',
    maxWidth: '85px',
    overflow: 'hidden',
  },
  voiceCell: {
    minWidth: '180px',
    width: '180px',
    maxWidth: '180px',
    position: 'relative',
    overflow: 'hidden',
  },
  llmCell: {
    minWidth: '110px',
    width: '110px',
    maxWidth: '110px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  transcriberCell: {
    minWidth: '100px',
    width: '100px',
    maxWidth: '100px',
  },
  languageCell: {
    minWidth: '120px',
    width: '120px',
    maxWidth: '120px',
  },
  profileCell: {
    minWidth: '150px',
    width: '150px',
    maxWidth: '150px',
  },
  agentIdCell: {
    minWidth: 0,
  },
  agentIdContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minWidth: 0,
  },
  agentIdText: {
    display: 'block',
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  agentIdCopyButton: {
    flexShrink: 0,
  },
  actionsCell: {
    minWidth: '100px',
    width: '100px',
    maxWidth: '100px',
  },
  genderIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  maleIcon: {
    fontSize: 22,
    color: '#2196F3',
  },
  femaleIcon: {
    fontSize: 22,
    color: '#E91E63',
  },
  voiceIconWithName: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  volumeUpIcon: {
    fontSize: 18,
    flexShrink: 0,
  },
  volumeOffIcon: {
    fontSize: 18,
    flexShrink: 0,
  },
  voiceNameText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  campaign: {
    padding: '30px',
  },
  campaign_header: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'space-between',
  },
  campaign_header_title: {
    display: 'flex',
    alignItems: 'center',
    placeItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
  },
  campaign_table: {
    marginTop: '20px',
  },
  campaign_table_row: {
    cursor: 'pointer',
  },
  campaign_table_first_cell: {
    paddingLeft: '0px',
  },
  campagin_table_sort_cell: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 3,
  },
  campagin_table_th: {
    flexBasis: 'min-content',
    textWrap: 'nowrap',
    fontSize: 11,
    fontWeight: 600,
  },
  subtitle: {
    fontSize: 18,
  },
  agent_table_th_advanced_settings: {
    display: 'flex',
    padding: '6px',
    justifyContent: 'flex-end',
  },
}));
